import { render, staticRenderFns } from "./bihuan.vue?vue&type=template&id=2d8e1526&scoped=true&"
import script from "./bihuan.vue?vue&type=script&lang=js&"
export * from "./bihuan.vue?vue&type=script&lang=js&"
import style0 from "./bihuan.vue?vue&type=style&index=0&id=2d8e1526&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8e1526",
  null
  
)

export default component.exports